import { DocumentUploadFormState } from "../types/document.types";

export const buildDocumentPayload = (state: DocumentUploadFormState) => {
  const formData = new FormData();
  
  // These keys MUST match what your backend Multer / upload service expects
  if (state.file) {
    formData.append("document_file", state.file);
  }
  formData.append("document_type_code", state.documentTypeCode);
  
  return formData;
};